module.exports = {"id":"183982","name":"Nolan Roux","rating":"73","photo":"./data/images/photos/4/183982.png","club":{"name":"FC Metz","logo":"./data/images/clubs/FCMetz.png"},"positions":["BU","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NolanRoux0.json
// module id = 3235
// module chunks = 0